import { styled } from '@mui/material/styles';
import { sizes } from 'src/themes/sizes';

export const Background = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.green.tint,
  width: '100%',
  height: '100vh',
  minHeight: sizes.box.minHeight.tall,
  overflowX: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    minHeight: '100vh',
  },
}));

export const LoginBox = styled('div')(({ theme }) => ({
  position: 'relative',
  marginTop: theme.spacing(18),
  backgroundColor: '#FFFFFF',
  width: '100%',
  maxWidth: sizes.box.maxWidth,
  height: sizes.box.minHeight.medium,
  boxShadow: '0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)',
  borderRadius: sizes.radius.md,
  padding: `${theme.spacing(7.5)} ${theme.spacing(10)} ${theme.spacing(5)}`,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    margin: 0,
    height: '100vh',
    maxWidth: '100vw',
    borderRadius: 0,
    padding: `${theme.spacing(12.5)} ${theme.spacing(3.5)} ${theme.spacing(3.75)}`,
  },
  [theme.breakpoints.down('xs')]: {
    padding: `${theme.spacing(7.5)} ${theme.spacing(2.5)} ${theme.spacing(2.5)}`,
  },
}));

export const Title = styled('h2')({
  fontSize: sizes.fontSize.h1,
  fontWeight: 700,
  margin: 0,
});

export const LoginDescription = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: sizes.fontSize.body,
  color: theme.palette.text.light,
}));

export const Logo = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(3),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2.5),
}));

export const LogoBox = styled('div')(({ theme }) => ({
  width: 'fit-content',
  minWidth: sizes.logo.box,
  height: sizes.logo.box,
  border: `1px solid ${theme.palette.green.light}`,
  boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06)',
  borderRadius: sizes.radius.md,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const Form = styled('form')(({ theme }) => ({
  marginTop: theme.spacing(5),
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
}));

export const HelperText = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: sizes.fontSize.bodyLarge,
  svg: {
    marginRight: theme.spacing(0.5),
  },
}));

export const FlexBetween = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const TextButton = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: sizes.field.textButton,
  color: theme.palette.green.primary,
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  '&:hover': {
    color: theme.palette.green.dark,
  },
  '&[disabled]': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
}));

export const CreateAccount = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const Info = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  height: '100%',
  svg: {
    marginTop: theme.spacing(0.25),
    marginRight: theme.spacing(0.5),
    flex: '0 0 20px',
  },
}));

export const InfoContainer = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: 0,
  bottom: 0,
  transform: `translateY(calc(100% + ${theme.spacing(1.5)}))`,
  [theme.breakpoints.down('sm')]: {
    width: 'fit-content',
    position: 'relative',
    marginTop: theme.spacing(7.5),
    transform: 'none',
  },
}));
